import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { printInfoMessage, routeConstants } from "../../../../shared/constants";
import { selectedFiltersAtom, yearsRangeAtom } from "../../../../shared/state/atoms";
import { useAtom } from "jotai";
import swal from "sweetalert";

function ChangeInMetroFilter() {
  const navigate = useNavigate();
  const [yearsRange] = useAtom(yearsRangeAtom);
  const [selectedFilters, setSelectedFilters] = useAtom(selectedFiltersAtom);

  useEffect(() => {
    if (!selectedFilters.startYear || !selectedFilters.endYear) {
      setSelectedFilters({
        ...selectedFilters,
        startYear: yearsRange[0],
        endYear: yearsRange[yearsRange.length - 1],
      });
    }
  }, [selectedFilters, setSelectedFilters, yearsRange]);

  const handlePrintNavigation = async () => {
    await swal("Please Note", printInfoMessage, "info");
    window.open(`${routeConstants.PDF_PREVIEW}/changeInMetroPdf`, "_blank");
  };

  const handlePrintAllNavigation = async () => {
    await swal("Please Note", printInfoMessage, "info");
    navigate(`${routeConstants.PDF_PREVIEW}/all`);
  };

  return (
    <div className="w-full">
      <div>
        <div style={{ fontSize: "16px" }} className="font-bold pb-5">
          Toggles:
        </div>
        <div className="flex justify-between mb-4">
          <label>Start Year:</label>
          <select
            className="border"
            name="filterViewas"
            value={selectedFilters?.startYear}
            onChange={(e) =>
              setSelectedFilters({
                ...selectedFilters,
                startYear: e.target.value,
              })
            }
          >
            {yearsRange
              .filter((year) => !selectedFilters.endYear || year <= selectedFilters.endYear)
              .map((e) => {
                return (
                  <option key={e} value={e}>
                    {e}
                  </option>
                );
              })}
          </select>
        </div>
        <div style={{ borderBottom: "1px solid lightgrey" }} className="flex justify-between mb-4 pb-8">
          <label>End Year:</label>
          <select
            className="border"
            name="filterViewas"
            value={selectedFilters?.endYear}
            onChange={(e) => {
              setSelectedFilters({
                ...selectedFilters,
                endYear: e.target.value,
              });
            }}
          >
            {yearsRange
              .filter((year) => !selectedFilters.startYear || year >= selectedFilters.startYear)
              .map((e) => {
                return (
                  <option key={e} value={e}>
                    {e}
                  </option>
                );
              })}
          </select>
        </div>
      </div>
      <div style={{ marginTop: "30px", borderBottom: "1px solid lightgrey", flexDirection: "column" }} className="flex justify-between mb-4 pb-8">
        <div style={{ fontSize: "16px" }} className="font-bold pb-5">
          Actions:
        </div>
        <div style={{ flexDirection: "row" }}>
          <button
            style={{
              border: "2px solid #F0A400",
              borderRadius: "50px",
              padding: "8px",
              paddingLeft: "14px",
              color: "#F0A400",
              width: "100%",
              marginBottom: "10px",
            }}
            className="font-sans"
            onClick={handlePrintNavigation}
          >
            Print Current Dashboard
          </button>
          <button
            style={{
              border: "2px solid #F0A400",
              borderRadius: "50px",
              padding: "8px",
              paddingLeft: "14px",
              color: "#F0A400",
              width: "100%",
            }}
            className="font-sans"
            onClick={handlePrintAllNavigation}
          >
            Print All Dashboards
          </button>
        </div>
      </div>
    </div>
  );
}

export default ChangeInMetroFilter;
